import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './assets/css/main.scss'
import { MotionPlugin } from '@vueuse/motion'

const app = createApp(App)
app.use(router).use(store).mount('#app')
app.use(MotionPlugin)
